import { TransactionColumn } from "@common/types/views/transactionViews";
import { CommandsDirectory } from "@components/commands/lib";
import { useTransactionBulkActions } from "@components/transactions/TransactionsBulkActions/useTransactionBulkActions";
import { useAccrualBulkAccept } from "./useAccrualBulkAccept";

const ACCRUAL_REVIEW_VISIBLE_COLUMNS = new Set<string>([
    TransactionColumn.COUNTERPARTY,
    TransactionColumn.CLASSES,
    TransactionColumn.ENTITY,
    TransactionColumn.NOTE,
    TransactionColumn.LEDGER,
    TransactionColumn.ACCRUAL_LEDGER,
    TransactionColumn.CATEGORY,
]);

export function useAccrualReviewBulkActions() {
    const transactionBulk = useTransactionBulkActions({
        visibleColumnIds: ACCRUAL_REVIEW_VISIBLE_COLUMNS,
        bulkCommandsDirectory: CommandsDirectory.ACCRUAL_REVIEW_BULK,
        transactionBulkCoaHeading: "modified cash ledger",
    });

    const accrualAccept = useAccrualBulkAccept();

    return {
        ...transactionBulk,
        ...accrualAccept,
    };
}
